import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import AbsProduct from '@/creditflowresearch/domain/Product/entities/AbsProduct';
import { parseProductIdsFromQuery } from '@/creditflowresearch/domain/Product/selectors/parseProductIdsFromQuery';
import { selectDefaultProductFallback } from '@/creditflowresearch/domain/Product/selectors/selectDefaultProductFallback';
import type { IProductSelectionContext } from '@/creditflowresearch/domain/Product/selectors/selectDefaultAbsProduct';

export const selectProductIdsForOtherRoute = (
  query: IQueryParams,
  productsList: IProduct[],
  accessibleProductsIds: string[],
  hasAccess: boolean,
): string[] => {
  const queryProductIds = parseProductIdsFromQuery(query.products as string, productsList);

  if (queryProductIds.length > 0) {
    return queryProductIds;
  }

  const context: IProductSelectionContext = {
    requiredProductType: undefined,
    accessibleProductIds: accessibleProductsIds,
    productsList,
    hasAccess,
  };

  const defaultProductId = selectDefaultProductFallback(context);
  return defaultProductId ? [defaultProductId] : [AbsProduct.PRODUCT_ID];
};
